import { NotifyApi } from "../http-common";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  showErrorNotification,
  showSuccessNotification,
} from "../../components/Mangement/modal/Tostify";
import { NOTIFICATION_MESSAGES } from "../../components/Mangement/modal/CreateAndEditNotify/FormDataConstants";
import { IFilterModel } from "../../slices/NotificationSlice";

export interface IAPIState {
  isLoading: boolean;
  error: string;
  status: boolean;
  refresh?: boolean;
  refreshOn?: string;
}

export interface IGetNotificationReq {
  userID: string;
  roles: string[];
  partnerID: string;
}
export interface INotificationCreateReq {
  title: string;
  description: string;
  level: string;
  effectiveDate: string;
  expiryDate: string;
  userId: string;
  notificationType: string;
  target?: ITargetNotification[];
}

export interface INotificationCreate extends INotificationCreateReq {
  file: FormData | null;
}
export interface ITargetNotification {
  resourceIDs: string[];
  resourceType: string;
}

export interface INotificationUpdateReq {
  notificationId: string;
  notification: INotificationCreateReq;
  file: FormData | null;
  RemoveFile: string[];
}
export interface IFileUpdate {
  updateFileReq: string;
  Files: FormData | null;
}
export interface INotificationUpdate {
  notificationId: string;
  notification: INotificationCreateReq;
}
export interface IDraftTosubmitReq {
  notificationIDs: string[];
  performedBy: string;
}
export interface IAddAssignee {
  notificationIDs: string[];
  assignee: string[];
  performedBy: string;
}
export interface IPublishNotification {
  notificationIDs: string[];
  performedBy: string;
  state: string;
  effectiveDate: string;
  expiryDate: string;
}

export interface IRejectNotification {
  notificationIDs: string[];
  performedBy: string;
  state: string;
  comments: string;
}
export interface IRecallNotification {
  performedBy: string;
  notificationIDs: string[];
}
export interface IFileAttachment {
  notificationID: string;
  Files: FormData | null;
}
export interface IFile {
  RemoveFile: string[];
  notificationID: string;
}

// Notification Controller
export const API_Notify = {
  GetNotificationByUserID: (req: IGetNotificationReq) => {
    return NotifyApi.post("api/Notification/get-notificationBy-userType", req);
  },
  DownloadFile: async (filePath: string) => {
    var fileNameList = filePath.split("\\");
    var fileName = fileNameList.at(-1);

    const response = await NotifyApi.post(
      "api/Notification/Download-file",
      null,
      {
        params: {
          filePath: filePath,
        },
        responseType: "blob",
        headers: {
          "Content-Type": "application/pdf",
        },
      }
    );

    let blob = new Blob([response.data], {
      type: response.headers["Content-type"],
    });
    const href = URL.createObjectURL(blob);
    // create "a" HTML element with href to file & click
    const link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", fileName ? fileName : "file.pdf"); //or any other extension
    document.body.appendChild(link);
    link.click();
    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  },
};

//API To Perform Action..
export const API_Notification = {
  CreateNotification: (req: INotificationCreateReq) => {
    return NotifyApi.post("api/Notification/CreateNotification", req);
  },
  UpdateNotification: (req: INotificationUpdate) => {
    return NotifyApi.put(
      `api/Notification/UpdateNotification?notificationId=${req.notificationId}`,
      req.notification
    );
  },
  DeleteNotification: (notificationID: string) => {
    return NotifyApi.delete(
      `api/Notification/DeleteNotification?NotificationID=${notificationID}`
    );
  },
  GetAllNotification_M1: () => {
    return NotifyApi.get("api/Notification/GetAllNotification");
  },
  GetNotificationByTarget: (req: ITargetNotification) => {
    return NotifyApi.put("api/Notification/GetNotificationBYTarget", req);
  },
  GetAllNotification_M2: () => {
    return NotifyApi.get("api/Notification/GetAllNotification_View1");
  },
  GetAllNotification_M3: (req: IFilterModel) => {
    return NotifyApi.post(`api/Notification/GetAllNotification_View2`, req);
  },
  GetNotificationByID: (notificationID: string) => {
    return NotifyApi.get(
      `api/Notification/get-notificationByID?notificationId=${notificationID}`
    );
  },
  GetNotificationByAssignee: (assignee: string) => {
    return NotifyApi.get(
      `/api/Notification/GetAllNotificationByAssignee?assigeeID=${assignee}`
    );
  },
  DraftToSubmit: (req: IDraftTosubmitReq) => {
    return NotifyApi.put(
      `api/Notification/DraftToSubmit?performedBy=${req.performedBy}`,
      req.notificationIDs
    );
  },
  AddAssignToNotification: (req: IAddAssignee) => {
    return NotifyApi.put("api/Notification/AddAssigneeToNotification", req);
  },
  PublishNotification: (req: IPublishNotification) => {
    return NotifyApi.put("api/Notification/PublishNotification", req);
  },
  RejectNotification: (req: IRejectNotification) => {
    return NotifyApi.put("api/Notification/RejectNotification", req);
  },
  RecallNotification: (req: IRecallNotification) => {
    return NotifyApi.put(
      `api/Notification/RecallNotification?performedBy=${req.performedBy}`,
      req.notificationIDs
    );
  },
  PublishedNotification: (req: string[]) => {
    return NotifyApi.put("api/Notification/GetAllPublishedNotification", req);
  },
  FileAttachement: (req: IFileAttachment) => {
    return NotifyApi.post(
      `api/Notification/FileAttach?notificationId=${req.notificationID}`,
      req.Files
    );
  },
  UpdateAttachement: (req: IFileUpdate) => {
    return NotifyApi.post(
      `api/Notification/FileUpdate?updateFileReq=${req.updateFileReq}`,
      req.Files
    );
  },
DownloadFile: async (notificationId: string, fileName: string): Promise<void> => {
  debugger;
    const response = await NotifyApi.post(
        `api/Notification/Download-files`,  
        null,
        { params: { notificationId, fileName }, responseType: "blob" }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
},

DownloadZipFile: async (notificationId: string): Promise<void> => {
    const response = await NotifyApi.post(
        `api/Notification/Download-Zip-files`,
        null,
        { params: { notificationId }, responseType: "blob" }
    );

    // Gets actual filename from backend — will be "20251104125812739.zip"
    const disposition = response.headers["content-disposition"];
    let zipFileName = `attachments_${notificationId}.zip`; // fallback only
    if (disposition && disposition.includes("filename=")) {
        zipFileName = disposition.split("filename=")[1].replace(/"/g, "").trim();
    }

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", zipFileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
},
  // DownloadFile: async (filePath: string) => {
  //   var fileNameList = filePath.split("\\");
  //   var fileName = fileNameList.at(-1);
  //   const response = await NotifyApi.post(
  //     "api/Notification/Download-files",
  //     null,
  //     {
  //       params: {
  //         filePath: filePath,
  //       },
  //       responseType: "blob",
  //       headers: {
  //         "Content-Type": "application/pdf",
  //       },
  //     }
  //   );
  //   let blob = new Blob([response.data], {
  //     type: response.headers["Content-type"],
  //   });
  //   const href = URL.createObjectURL(blob);
  //   // create "a" HTML element with href to file & click
  //   const link = document.createElement("a");
  //   link.href = href;
  //   link.setAttribute("download", fileName ? fileName : "file.pdf"); //or any other extension
  //   document.body.appendChild(link);
  //   link.click();
  //   // clean up "a" element & remove ObjectURL
  //   document.body.removeChild(link);
  //   URL.revokeObjectURL(href);
  // },
  DeleteFile: (filePath: string) => {
    return NotifyApi.delete(`api/Notification/FileDelete?filePath=${filePath}`);
  },
  DeleteDirectory: (notificationID: string) => {
    return NotifyApi.delete(
      `api/Notification/DeleteDirectory?notificationId=${notificationID}`
    );
  },
};

//Create Notification
export const CreateNotification = createAsyncThunk(
  "notification/Create",
  async (request: INotificationCreate) => {
    try {
      const response = await API_Notification.CreateNotification({
        description: request.description,
        effectiveDate: request.effectiveDate,
        expiryDate: request.expiryDate,
        level: request.level,
        notificationType: request.notificationType,
        title: request.title,
        userId: request.userId,
        target: request.target,
      });
      const createResponse = await API_Notification.FileAttachement({
        notificationID: response.data.data.id,
        Files: request.file,
      });
      if (createResponse.status === 200) {
        showSuccessNotification(NOTIFICATION_MESSAGES.CREATE_SUCCESS);
        return createResponse.data;
      }
    } catch (err) {
      showErrorNotification(NOTIFICATION_MESSAGES.CREATE_ERROR);
    }
  }
);

//Update Notification
export const UpdateNotification = createAsyncThunk(
  "notification/Update",
  async (request: INotificationUpdateReq) => {
    try {
      let UpdateFile = {} as IFile;
      UpdateFile.RemoveFile = request.RemoveFile;
      UpdateFile.notificationID = request.notificationId;
      const response = await API_Notification.UpdateNotification({
        notification: {
          description: request.notification.description,
          effectiveDate: request.notification.effectiveDate,
          expiryDate: request.notification.expiryDate,
          level: request.notification.level,
          notificationType: request.notification.notificationType,
          title: request.notification.title,
          userId: request.notification.userId,
          target: request.notification.target,
        },
        notificationId: request.notificationId,
      });
      const UpdateResponse = await API_Notification.UpdateAttachement({
        Files: request.file,
        updateFileReq: JSON.stringify(UpdateFile),
      });
      if (response.status === 200) {
        showSuccessNotification(NOTIFICATION_MESSAGES.UPDATE_SUCCESS);
      }
      return UpdateResponse.data;
    } catch (err) {
      showErrorNotification(NOTIFICATION_MESSAGES.UPDATE_ERROR);
    }
  }
);

//Delete Notification
export const DeleteNotification = createAsyncThunk(
  "notification/Delete",
  async (notificationID: string) => {
    try {
      const response = await API_Notification.DeleteNotification(
        notificationID
      );
      if (response.status === 200) {
        showSuccessNotification(NOTIFICATION_MESSAGES.DELETE_SUCCESS);
      }
      return response.data;
    } catch (err) {
      showErrorNotification(NOTIFICATION_MESSAGES.DELETE_ERROR);
    }
  }
);

//Get All Notification M1
export const GetAllNotification_M1 = createAsyncThunk(
  "notification/GetAll",
  async () => {
    try {
      const response = await API_Notification.GetAllNotification_M1();
      return response.data.data;
    } catch (err) {}
  }
);

//Get All Notification M2
export const GetAllNotification_M2 = createAsyncThunk(
  "notification/GetAll_M2",
  async () => {
    try {
      const response = await API_Notification.GetAllNotification_M2();
      return response.data.data;
    } catch (err) {}
  }
);

export const GetPulishedNotification = createAsyncThunk(
  "notification/PulishedNotification",
  async (partnertype: string[]) => {
    try {
      const response = await API_Notification.PublishedNotification(
        partnertype
      );
      return response.data.data;
    } catch (err) {
      // showErrorNotification(
      //   "Error Fetching Data, something went wrong, please try again later"
      // );
      console.log("Error Fetching Data, something went wrong, please try again later");
    }
  }
);

//Get All Notification M3
export const GetAllNotification_M3 = createAsyncThunk(
  "notification/GetAll_M3",
  async (req: IFilterModel) => {
    try {
      const response = await API_Notification.GetAllNotification_M3(req);
      return response.data.data;
    } catch (err) {
      // showErrorNotification(
      //   "Error Fetching Data, something went wrong, please try again later"
      // );
      console.log("Error Fetching Data, something went wrong, please try again later");
    }
  }
);

//Get Notification BY ID
export const GetNotificationByID = createAsyncThunk(
  "notification/ByID",
  async (notificationID: string) => {
    try {
      const response = await API_Notification.GetNotificationByID(
        notificationID
      );
      return response.data;
    } catch (err) {}
  }
);

//Get Notification BY Target
export const GetNotificationBYTarget = createAsyncThunk(
  "notification/Target",
  async (request: ITargetNotification) => {
    try {
      const response = await API_Notification.GetNotificationByTarget(request);
      return response.data;
    } catch (err) {}
  }
);

//Draft to Submit Notification
export const DraftToSubmit = createAsyncThunk(
  "notification/DraftToSubmit",
  async (request: IDraftTosubmitReq) => {
    try {
      const response = await API_Notification.DraftToSubmit(request);
      if (response.status === 200) {
        showSuccessNotification(NOTIFICATION_MESSAGES.DRAFT_SUCCESS);
      } else {
        showErrorNotification(NOTIFICATION_MESSAGES.DRAFT_ERROR);
      }
      return response.data;
    } catch (err) {}
  }
);

//Add Or Update Assignee to the Notification
export const UpdateAssignToNotification = createAsyncThunk(
  "notification/UpdateAssignee",
  async (request: IAddAssignee) => {
    try {
      const response = await API_Notification.AddAssignToNotification(request);
      if (response.status === 200) {
        showSuccessNotification(NOTIFICATION_MESSAGES.ASSIGN_SUCCESS);
      } else {
        showErrorNotification(NOTIFICATION_MESSAGES.ASSIGN_ERROR);
      }
      return response.data;
    } catch (err) {}
  }
);

//Publish the Notification
export const PublishNotification = createAsyncThunk(
  "notification/Publish",
  async (request: IPublishNotification) => {
    try {
      const response = await API_Notification.PublishNotification(request);
      if (response.status === 200) {
        showSuccessNotification(NOTIFICATION_MESSAGES.PUBLISH_SUCCESS);
      } else {
        showErrorNotification(NOTIFICATION_MESSAGES.PUBLISH_ERROR);
      }
      return response.data;
    } catch (err) {}
  }
);

//Reject the Notification
export const RejectNotification = createAsyncThunk(
  "notification/Reject",
  async (request: IRejectNotification) => {
    try {
      const response = await API_Notification.RejectNotification(request);
      if (response.status === 200) {
        showSuccessNotification(NOTIFICATION_MESSAGES.REJECT_SUCCESS);
      } else {
        showErrorNotification(NOTIFICATION_MESSAGES.REJECT_ERROR);
      }
      return response.data;
    } catch (err) {}
  }
);

//Recall the Notification On After Publish
export const RecallNotification = createAsyncThunk(
  "notification/Recall",
  async (request: IRecallNotification) => {
    try {
      const response = await API_Notification.RecallNotification(request);
      if (response.status === 200) {
        showSuccessNotification(NOTIFICATION_MESSAGES.RECALL_SUCCESS);
      } else {
        showErrorNotification(NOTIFICATION_MESSAGES.RECALL_ERROR);
      }
      return response.data;
    } catch (err) {}
  }
);

//Get All Notification BY Assignee
export const GetAllNotificationByAssignee = createAsyncThunk(
  "notification/ByAssignee",
  async (assigeeID: string) => {
    try {
      const response = await API_Notification.GetNotificationByAssignee(
        assigeeID
      );
      return response.data;
    } catch (err) {}
  }
);
